<template>
  <div
    v-if="showCommentsToggle"
    data-png-ignore
    class="requisition-report-widget-comments-toggle"
  >
    <v-menu
      location="top right"
      :close-on-content-click="false"
      :model-value="isActive"
      content-class="requisition-report-widget-comments-toggle-content"
      @update:model-value="isActive = $event;"
    >
      <template #activator="{ props }">
        <div v-bind="props">
          <DpplSvg
            class="comment-icon"
            :class="{ active: isActive }"
            :file-name="'icons/Icon_Comment_Plus'"
          />
        </div>
      </template>

      <RequisitionReportWidgetCommentsComposer
        v-bind="$props"
        @message-send="onMessageSend"
        @close="onClose"
      />
    </v-menu>
  </div>
</template>

<script>
import { useCommenting } from '@/stores/commenting/commenting';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { useInsightsExport } from '@/stores/insights/export';
import { mapActions } from 'pinia';
import RequisitionReportWidgetCommentsComposer
  from './RequisitionReportWidgetCommentsComposer.vue';

export default {
  name: 'RequisitionReportWidgetCommentsToggle',
  components: { DpplSvg, RequisitionReportWidgetCommentsComposer },

  props: {
    reqId: { type: String, default: '' },
    reqUuid: { type: String, default: '' },
    widgetId: { type: String, default: '' },
    screenshotSelector: { type: String, default: '' },
    threadName: { type: String, default: '' },
  },

  data() {
    return {
      isActive: false,
    };
  },

  computed: {
    showCommentsToggle() {
      return useCommenting().showCommentsToggle;
    },
  },

  methods: {
    ...mapActions(useInsightsExport, ['updateExportInProgress']),

    async onMessageSend(event) {
      const [{ messageId, threadId }] = event.detail;

      const widgetEl = this.$root.$el.querySelector(this.screenshotSelector);
      if (widgetEl) {
        // This forces the candidate table to close temporarily for screenshot
        this.updateExportInProgress(true);

        await useCommenting().addScreenshotToWidgetMessage({ threadId, messageId, widgetEl });

        this.updateExportInProgress(false);
      }

      this.isActive = false;

      // show comment sidebar - that's where the new message appears
      useCommenting().setShowComments(true);
    },

    onClose() {
      this.isActive = false;
    },
  },
};
</script>

<style lang="less">
.requisition-report-widget-comments-toggle-content {
  @import '@/less/mixins';
  .shadow();
}
</style>

<style scoped lang="less">
.requisition-report-widget-comments-toggle {
  cursor: pointer;

  .comment-icon {
    fill: fade(@grey-900, 50%);
    margin-top: 4px;
    &.active {
      fill: @icon-brand;
    }
    &:hover {
      fill: @icon-brand;
    }
  }
}
</style>
